export const BORDER = [
  'top',
  'bottom',
  'top-bottom',
  ''
]

export const ELEVATION = [
  0,
  1
]
